import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  logout,
  nullVerifyData,
  reset,
  signup,
  skipLogin,
  update,
  verify,
} from "../../store/auth";

function useAuthStore() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth || {});
  const {
    accessContextReady,
    authBypassed,
    businessId: userBusinessId,
    clientId: userClientId,
    data: Data,
    email,
    error,
    id: userId,
    isAuth,
    refreshToken,
    role,
    status,
    token,
    ui = {},
    user,
    userloginid,
  } = auth;
  const { loading = false, msg: message = "" } = ui;

  const loginAction = useCallback((params) => dispatch(login(params)), [dispatch]);
  const logoutAction = useCallback(() => dispatch(logout()), [dispatch]);
  const skip = useCallback(() => dispatch(skipLogin()), [dispatch]);
  const resetAction = useCallback((params) => dispatch(reset(params)), [dispatch]);
  const signupAction = useCallback(
    (params) => dispatch(signup(params)),
    [dispatch]
  );
  const verifyAction = useCallback(
    (params) => dispatch(verify(params)),
    [dispatch]
  );
  const updateAction = useCallback(
    (params) => dispatch(update(params)),
    [dispatch]
  );
  const nullVerifyDataAction = useCallback(
    (params) => dispatch(nullVerifyData(params)),
    [dispatch]
  );

  return {
    isAuth,
    token,
    role,
    refreshToken,
    status,
    error,
    loading,
    user,
    message,
    Data,
    userId,
    userloginid,
    email,
    authBypassed,
    accessContextReady,
    userClientId,
    userBusinessId,
    loginAction,
    logoutAction,
    skip,
    resetAction,
    signupAction,
    verifyAction,
    updateAction,
    nullVerifyDataAction,
  };
}

export default useAuthStore;
